module.exports = __webpack_public_path__ + "static/img/guide3.6605a0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide3.jpg
// module id = LWju
// module chunks = 1